/* sucrase/dist/esm/util/getTSImportedNames.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.default = getTSImportedNames;
    const tslib_1 = require("tslib");
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    const getImportExportSpecifierInfo_1 = tslib_1.__importDefault(require("14d4ae78a4") /* ./getImportExportSpecifierInfo */);
    /**
     * Special case code to scan for imported names in ESM TypeScript. We need to do this so we can
     * properly get globals so we can compute shadowed globals.
     *
     * This is similar to logic in CJSImportProcessor, but trimmed down to avoid logic with CJS
     * replacement and flow type imports.
     */
    function getTSImportedNames(tokens) {
        const importedNames = new Set();
        for (let i = 0; i < tokens.tokens.length; i++) {
            if (tokens.matches1AtIndex(i, types_1.TokenType._import) &&
                !tokens.matches3AtIndex(i, types_1.TokenType._import, types_1.TokenType.name, types_1.TokenType.eq)) {
                collectNamesForImport(tokens, i, importedNames);
            }
        }
        return importedNames;
    }
    function collectNamesForImport(tokens, index, importedNames) {
        index++;
        if (tokens.matches1AtIndex(index, types_1.TokenType.parenL)) {
            // Dynamic import, so nothing to do
            return;
        }
        if (tokens.matches1AtIndex(index, types_1.TokenType.name)) {
            importedNames.add(tokens.identifierNameAtIndex(index));
            index++;
            if (tokens.matches1AtIndex(index, types_1.TokenType.comma)) {
                index++;
            }
        }
        if (tokens.matches1AtIndex(index, types_1.TokenType.star)) {
            // * as
            index += 2;
            importedNames.add(tokens.identifierNameAtIndex(index));
            index++;
        }
        if (tokens.matches1AtIndex(index, types_1.TokenType.braceL)) {
            index++;
            collectNamesForNamedImport(tokens, index, importedNames);
        }
    }
    function collectNamesForNamedImport(tokens, index, importedNames) {
        while (true) {
            if (tokens.matches1AtIndex(index, types_1.TokenType.braceR)) {
                return;
            }
            const specifierInfo = (0, getImportExportSpecifierInfo_1.default)(tokens, index);
            index = specifierInfo.endIndex;
            if (!specifierInfo.isType) {
                importedNames.add(specifierInfo.rightName);
            }
            if (tokens.matches2AtIndex(index, types_1.TokenType.comma, types_1.TokenType.braceR)) {
                return;
            }
            else if (tokens.matches1AtIndex(index, types_1.TokenType.braceR)) {
                return;
            }
            else if (tokens.matches1AtIndex(index, types_1.TokenType.comma)) {
                index++;
            }
            else {
                throw new Error(`Unexpected token: ${JSON.stringify(tokens.tokens[index])}`);
            }
        }
    }
}
